export const components = (formula) =>
  (Array.isArray(formula?.cnts) ? formula.cnts : []).filter(
    (entry) => entry && typeof entry === 'object'
  );

export const isStandalone = (state) => state.configurations.is_standalone;

export function formulaBase(formula, product) {
  if (!formula || !product) return null;
  return (
    product.basepaints?.find((base) =>
      formula.baseid != null
        ? base.baseid === formula.baseid
        : base.basecode === formula.basecode
    ) || null
  );
}

export function formatFormulaAmount(formatter, volume, specificgravity = 1) {
  if (!formatter || !Number.isFinite(volume)) return '';
  const value = formatter.format({ volume, specificgravity });
  const unit = formatter.getUnitName();
  return value && unit ? `${value} ${unit}` : value;
}

export function supportContext(item) {
  const messages = [...(item?.messages || [])].sort(
    (a, b) =>
      Date.parse(a.created_at) - Date.parse(b.created_at) ||
      a.formulasupportmessageid - b.formulasupportmessageid
  );
  const original = messages.find((message) => message.sender === 'POS');
  const response = messages.filter((message) => message.sender === 'LAB').pop();
  const context = { ...original };
  for (const [key, value] of Object.entries(response || {})) {
    if (value != null && value !== '') context[key] = value;
  }
  return {
    messages,
    original,
    response,
    context,
    received: response?.created_at || original?.created_at || item?.created_at,
  };
}

export function resolveFormula(message, products, cntcodemap) {
  const snapshot = message?.formula;
  if (!snapshot || Array.isArray(snapshot) || typeof snapshot !== 'object')
    return { problem: 'incomplete' };
  if (
    !Number.isInteger(message.productid) ||
    typeof message.cansizecode !== 'string' ||
    !message.cansizecode ||
    typeof snapshot.basecode !== 'string' ||
    !snapshot.basecode ||
    (snapshot.baseid != null &&
      (!Number.isInteger(snapshot.baseid) || snapshot.baseid <= 0)) ||
    !Number.isFinite(snapshot.basevolume) ||
    snapshot.basevolume <= 0 ||
    !Array.isArray(snapshot.cnts) ||
    !snapshot.cnts.length
  )
    return { problem: 'incomplete' };
  const product = products.find((item) => item.productid === message.productid);
  const base = product?.basepaints?.find((item) =>
    snapshot.baseid != null
      ? item.baseid === snapshot.baseid
      : item.basecode === snapshot.basecode
  );
  const can = base?.cans?.find(
    (item) => item.cansizecode === message.cansizecode
  );
  if (!product || !base || !can) return { problem: 'catalogue' };
  const codes = new Set();
  const resolvedComponents = [];
  for (const component of snapshot.cnts) {
    const cnt = cntcodemap.get(component?.cntcode);
    if (
      !cnt ||
      codes.has(cnt.cntcode) ||
      !Number.isFinite(component.volume) ||
      component.volume <= 0 ||
      (product.cntinsystem?.length &&
        !product.cntinsystem.includes(cnt.cntid)) ||
      (cnt.abaseid != null &&
        !(
          product.blendedbase != null &&
          product.basecnts?.some((item) => item.abaseid === cnt.abaseid)
        ))
    )
      return { problem: 'components' };
    codes.add(cnt.cntcode);
    resolvedComponents.push({
      cntid: cnt.cntid,
      cntcode: cnt.cntcode,
      volume: component.volume,
    });
  }
  return { product, base, can, components: resolvedComponents, problem: null };
}

export function formulaProblem(message, products, cntcodemap) {
  return resolveFormula(message, products, cntcodemap).problem;
}
